import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import {
    createDesignation,
    fetchAllDesignations,
    resetStatus,
} from "../../store/slices/designation";

import { fetchAllDesignations as fetchAllDesignationsUserSlice } from "../../store/slices/userSlice";

function DesignationCreatePopup({ show, onHide, onClose, onSuccess, onCreated }) {
    const dispatch = useDispatch();

    const { loading, errorMessage } = useSelector(
        (state) => state.designation || {}
    );

    const [designationName, setDesignationName] = useState("");
    const [designationDescription, setDesignationDescription] = useState("");

    useEffect(() => {
        if (!show) return;
        setDesignationName("");
        setDesignationDescription("");
        dispatch(resetStatus());
    }, [show, dispatch]);

    const handleClose = () => {
        dispatch(resetStatus());
        onHide?.();
        onClose?.();
    };

    const notifyCreated = (payload) => {
        onSuccess?.(payload);
        onCreated?.(payload);
    };

    const handleCreate = async () => {
        const name = (designationName || "").trim();
        const description = (designationDescription || "").trim();

        if (!name) return;

        const resultAction = await dispatch(
            createDesignation({ name, description })
        );

        if (createDesignation.fulfilled.match(resultAction)) {
            const created = resultAction.payload;

            await dispatch(fetchAllDesignations());
            await dispatch(fetchAllDesignationsUserSlice());

            notifyCreated({
                id: created?.id,
                name: created?.name,
            });

            dispatch(resetStatus());
            handleClose();
        }
    };

    return (
        <Modal show={!!show} onHide={handleClose} backdrop="static" centered>
            <Modal.Header closeButton>
                <Modal.Title>Add New Designation</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="form_group">
                    <label>Designation Name</label>
                    <input
                        type="text"
                        className="form-control pl_16"
                        placeholder="Enter designation name"
                        value={designationName}
                        onChange={(e) => setDesignationName(e.target.value)}
                    />
                </div>

                <div className="form_group">
                    <label>Description</label>
                    <textarea
                        className="form-control pl_16"
                        placeholder="Enter designation description"
                        rows={4}
                        value={designationDescription}
                        onChange={(e) => setDesignationDescription(e.target.value)}
                    />
                </div>

                {errorMessage ? (
                    <div className="mt_10 text-danger">{errorMessage}</div>
                ) : null}
            </Modal.Body>

            <Modal.Footer>
                <Button className="btn_outline_secondary" onClick={handleClose}>
                    Cancel
                </Button>

                <Button
                    className="btn_primary"
                    onClick={handleCreate}
                    disabled={!!loading}
                >
                    {loading ? "Creating..." : "Create"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DesignationCreatePopup;